module.exports = __webpack_public_path__ + "media/customizations/bramlife/back-1c15e632f78fa93a0ae095b3525b7f9f.jpg";